module.exports = __webpack_public_path__ + "static/media/upload-icon.cff8075a.svg";